function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "linkedin_svg__a",
  d: "M0 0h32v32H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "linkedin_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#linkedin_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M25.898 26.863H21.57v-6.777c0-1.617-.03-3.695-2.25-3.695-2.254 0-2.6 1.76-2.6 3.578v6.894h-4.327V12.927h4.154v1.904h.058c.578-1.095 1.99-2.25 4.098-2.25 4.386 0 5.195 2.886 5.195 6.638v7.644zM7.512 11.023a2.512 2.512 0 010-5.023 2.512 2.512 0 010 5.022zm-2.167 15.84h4.332V12.927H5.345v13.936z",
  fill: "#FEFEFE",
  mask: "url(#linkedin_svg__b)"
}));

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "e779b933faaa5a63be28ac971e007337.svg";
export { SvgLinkedin as ReactComponent };